/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'
import router from './router'
import * as Sentry from '@sentry/vue'
import { registerLicense } from '@syncfusion/ej2-base'
registerLicense(import.meta.env.VITE_SYNC_FUSION_KEY)

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://26ee44e61c86a0523f7be1bc26b0e854@o4507710674436096.ingest.us.sentry.io/4507992730370048',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

registerPlugins(app)

app.mount('#app')
